import { FC } from 'react';
import Text from '@components/common/text';
import Button from '@components/common/button';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { FontStyle } from '@domain/constant/fontStyle';
import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface Step1Props {
  onNext: () => void;
}

const Step1: FC<Step1Props> = ({ onNext }) => {
  const { data } = useUserInfo();
  const onClickIpin = () => V2Route.openKcbIpinPage();

  return (
    <>
      <Text className={cx('noticeArea')} fontStyle={FontStyle.H5_B}>
        {data?.name}님의 본인 확인을 위해
        <br />
        본인 인증이 필요해요.
        <div className={cx('noticeIcon')} />
      </Text>

      <div className={cx('selectArea')}>
        <Button onClick={onNext}>휴대폰 본인 인증</Button>
        <Button onClick={onClickIpin} theme="secondary">
          아이핀 인증
        </Button>
      </div>
    </>
  );
};

Step1.displayName = 'Step1';
export default Step1;
